import type { ComponentType } from 'react'

import { TRIAL_PAGE_GRANT } from '@/modules/account/constants'
import { GatherStatementsScene } from './GatherStatementsScene'
import { SupportedDocumentsScene } from './SupportedDocumentsScene'
import { UprightPagesScene } from './UprightPagesScene'

export interface UploadGuideStep {
  key: string
  title: string
  description: string
  Scene: ComponentType
}

export const uploadGuideSteps: UploadGuideStep[] = [
  {
    key: 'gather',
    title: 'Gather your statements',
    description: `Collect the statements for the case as PDF files. Your trial extracts the first ${TRIAL_PAGE_GRANT} pages you upload, so start with the ones that matter most.`,
    Scene: GatherStatementsScene,
  },
  {
    key: 'upright',
    title: 'Check pages are upright and legible',
    description:
      'Turn sideways or upside-down pages the right way up before you upload. Blurry or cut-off scans may not be extracted.',
    Scene: UprightPagesScene,
  },
  {
    key: 'documents',
    title: 'We extract bank & credit card statements, and check images',
    description: `We do not process any other kind of document, such as invoices, investment statements, emails, and pay stubs. All uploads count towards your ${TRIAL_PAGE_GRANT} trial pages.`,
    Scene: SupportedDocumentsScene,
  },
]
